import { Component } from "react";
import "./CV.css";
import profilePic from "./profile-pic.png";
import PersonalDetails from "./PersonalDetail/PersonalDetails";
import ProfessionalProfile from "./ProfessionalProfile/ProfessionalProfile";
import Experience from "./Experience/Experience";
import downloadIcon from "./img/download.png";
import Education from "./Eduaction/Education";
import LeftBarList from "./LeftBarList/LeftBarList";
import Analytics from "../utils/analytics";
import {
  experiences,
  currentTitle,
  professionalProfile
} from "../data/experiences";

class CV extends Component {
  componentDidMount() {
    // Track CV page view
    Analytics.trackCVOpen();
  }

  handleDownloadClick = () => {
    // Track CV download
    Analytics.trackCVDownload();
  };

  render() {
    return (
      <div className="cv">
        <div className="left-bar">
          <p className="name">Nour Sandid</p>
          <p className="title">{currentTitle}</p>
          <img className="profile-pic" src={profilePic} alt="Profile" />
          <div className="left-bar-download-box">
            <img
              className="left-bar-download-box-icon"
              alt="download"
              src={downloadIcon}
            />
            <a
              className="left-bar-download-box-button"
              href="/Nour%20Sandid.pdf"
              download
              onClick={this.handleDownloadClick}
            >
              Download
            </a>
          </div>
          <PersonalDetails />
          <ProfessionalProfile details={professionalProfile} />
          <Education />
          <LeftBarList
            title="Mobile"
            details={[
              "Swift (UIKit + SwiftUI), Objective-C",
              "Android (Kotlin/Java basics)",
              "React Native, JavaScript, TypeScript"
            ]}
          />
          <LeftBarList
            title="Web / Backend"
            details={["Vue.js", "Node.js", "WebSockets"]}
          />
          <LeftBarList
            title="DevTools / CI"
            details={[
              "Xcode, XcodeGen",
              "Fastlane, Bitrise, GitHub Actions, Jenkins",
              "Docker, Linux",
              "Oracle SOA Suite 12c, Weblogic"
            ]}
          />
          <LeftBarList
            title="Practices"
            details={[
              "MVVM, RxSwift, Clean Swift, VIPER",
              "SonarQube",
              "AI-native development (Claude)"
            ]}
          />
          <LeftBarList
            title="Core Competencies"
            details={[
              "Engineering leadership and technical direction",
              "Cross-functional partnership with Product, Design, and Engineering leadership",
              "Mentorship, coaching, and team development",
              "Delivery ownership and roadmap execution",
              "Architecture strategy and tech-debt prioritization",
              "Hiring, code review culture, and quality standards",
              "Developer productivity and CI/CD investment"
            ]}
          />
        </div>
        <div className="experiences">
          <p className="experiences-title">Professional Experience</p>
          {experiences.flatMap((company) =>
            company.roles.map((role, index) => (
              <Experience
                key={`${company.name}-${role.position}`}
                logo={index === 0 ? company.logo : undefined}
                title={index === 0 ? company.name : undefined}
                link={index === 0 ? company.link : undefined}
                position={role.position}
                date={`${role.from} - ${role.to}`}
                details={role.highlights}
              />
            ))
          )}
        </div>
      </div>
    );
  }
}

export default CV;
